import { render, staticRenderFns } from "./AdvancedColorPicker.vue?vue&type=template&id=5277adad&scoped=true"
import script from "./AdvancedColorPicker.vue?vue&type=script&lang=js"
export * from "./AdvancedColorPicker.vue?vue&type=script&lang=js"
import style0 from "./AdvancedColorPicker.vue?vue&type=style&index=0&id=5277adad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5277adad",
  null
  
)

export default component.exports